import styled from "styled-components";

export const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexBoxRow = styled.div`
  display: flex;
`;

export const FlexX = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FlexY = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FlexXY = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
